/**
 * Hook pour le profil utilisateur Tracking.
 */
import { useCallback } from "react";
import useSWR from "swr";
import { useAuthentication } from "./useAuthentication";
import {
  fetchTrackingProfile,
  changeTrackingPassword,
  type TrackingProfile,
  type ChangePasswordPayload,
} from "../services/tracking/profileService";

const PROFILE_KEY = "tracking-profile";

export function useTrackingProfile() {
  const { user } = useAuthentication();
  const token = user?.auth?.access_token;

  const { data: profile, error, isLoading, mutate } = useSWR<TrackingProfile>(
    token ? [PROFILE_KEY, token] : null,
    () => fetchTrackingProfile(token),
    { revalidateOnFocus: false }
  );

  const changePassword = useCallback(
    async (payload: ChangePasswordPayload) => {
      const result = await changeTrackingPassword(token, payload);
      return result;
    },
    [token]
  );

  const refetch = useCallback(() => mutate(), [mutate]);

  return {
    profile: profile ?? null,
    isLoading,
    error,
    refetch,
    changePassword,
    accessToken: token,
  };
}

export type { TrackingProfile, ChangePasswordPayload };
